import React from 'react';
import { Image as ImageType } from '../../../commonTypes/image';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import fluidGridColumns from '../../../theme/fluidGridColumns';
import { GridItem, GridItemProps } from '../../Grid';
import { Container, StyledGrid, StyledLogo, StyledRichText } from './styles';

export type FooterComplianceProps = {
  compliance: string;
  logo?: ImageType;
  alignLeft?: boolean;
  complianceGridItemProps: GridItemProps;
  onLinkClick?: (label: string) => void;
} & ComponentProps;

const FooterCompliance: React.FC<FooterComplianceProps> = ({
  compliance,
  logo,
  complianceGridItemProps,
  alignLeft,
  onLinkClick,
  ...props
}) => {
  const logoGridItemProps: GridItemProps = {
    desktop: 3,
    tabletLandscape: 3,
    tabletPortrait: 3,
    mobile: fluidGridColumns.mobile,
  };

  return (
    <Container {...componentProps(props)}>
      <StyledGrid alignLeft={alignLeft}>
        <GridItem {...complianceGridItemProps}>
          <StyledRichText html={compliance} onLinkClick={onLinkClick} focusable />
        </GridItem>
        {logo && (
          <GridItem {...logoGridItemProps}>
            <StyledLogo
              src={logo.url}
              alt={logo.altText}
              height={logo.height}
              width={logo.width}
            />
          </GridItem>
        )}
      </StyledGrid>
    </Container>
  );
};

export default applyComponentTheme(FooterCompliance, 'FooterCompliance');
